import { Grid, Heading, TargetLogo } from '@design-systems/canvas-ui'

export const LogoSlot = () => {
  return (
    <Grid.Container align="center">
      <Grid.Item>
        <TargetLogo size="lg" />
      </Grid.Item>
      <Grid.Item>
        <Heading size={3}>PLM</Heading>
      </Grid.Item>
    </Grid.Container>
  )
}

export default LogoSlot
